import {useOutlet, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import Footer from "components/Footer";
import NavBar from "components/NavBar";
import useBotLink from "assets/hooks/useBotLink";


export const BaseLayout = () => {
    const outlet = useOutlet();
    const {i18n} = useTranslation();
    const {lang} = useParams();
    const {link} = useBotLink()

    useEffect(() => {
        if (lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);


    return <>
        <NavBar botLink={link} />
        {outlet}
        <Footer  botLink={link}/>
    </>
};
